if (!customElements.get('parallax-effect')) {
  class ParallaxEffect extends HTMLElement {
    constructor() {
      super();
      this.isAnimating = false;
      this.bindOnWheel = this.onWheel.bind(this);
      this.bindOnTouchStart = this.onTouchStart.bind(this);
      this.bindOnTouchMove = this.onTouchMove.bind(this);
      this.bindOnTouchEnd = this.onTouchEnd.bind(this);
      this.bindOnResize = this.onResize.bind(this);
      this.touchStartY = 0;
      this.touchStartX = 0;
      this.isSwiping = false;
      this.swipeDirection = null;

      // Variables to control touchpad scroll
      this.wheelDeltaAccumulator = 0;
      this.wheelTimeout = null;
      this.lastWheelTime = 0;
      this.wheelThreshold = 120; // Minimum threshold to change section
      this.wheelEventCount = 0; // Count wheel events in current gesture
      this.wheelBlockTimeout = null; // Block period after navigation
      this.isWheelBlocked = false; // Flag to block wheel during cooldown
      this.wheelGestureStartTime = 0; // When the current gesture started
      this.minGestureDuration = 150; // Minimum time a gesture must last (ms)
      this.lastNavigationTime = 0; // Last time we navigated
      this.lastInputWasMouse = false; // Track if last navigation was with mouse
      this.mouseNavigationCooldown = 200; // Minimum time between mouse wheel navigations (ms)
      this.touchpadNavigationCooldown = 1200; // Minimum time between touchpad navigations (ms)
    }

    connectedCallback() {
      this.setUp();
    }

    disconnectedCallback() {
      this.removeEvents();
    }

    setUp() {
      this.pageHeader = document.querySelector('.header-wrapper');
      if(this.pageHeader) {
        if (this.pageHeader.dataset.stickyType == 'reduce-logo-size') this.pageHeader.dataset.stickyType = 'always'
      }

      this.slider = this.querySelector('.parallax-effect__list');
      this.allSlides = Array.from(this.querySelectorAll('.shopify-section')).filter(slide => !slide.classList.contains('section--apps') && !slide.classList.contains('section--parallax-effect') && !slide.classList.contains('section-content-popup')&& !slide.classList.contains('section-newsletter-popup'));
      this.allSlides.forEach(slide => {
        const slideElement = slide.innerHTML;
        slide.innerHTML = '';

        const wrapper = document.createElement('div');
        wrapper.classList.add('parallax-effect__section-wrapper');
        wrapper.innerHTML = slideElement;
        slide.appendChild(wrapper);

        if(slide.querySelector('.accordion')) {
          const details = slide.querySelectorAll('.accordion > details');
          details.forEach(detail => {
            detail.classList.remove('loaded');
            detail.removeAttribute('listened');
          })
          closingAccordions(`#${slide.id} .accordion > details`)
        }
      })

      if (this.hasAttribute('design-mode')) return;

      this.slides = [];
      this.slidesPositions = [];
      this.currentPosition = 0;
      this.currentIndex = 0;
      document.documentElement.classList.add('first-slide');


      this.computedStyles = getComputedStyle(this);
      this.topOffset = +computePixelValue(this.computedStyles.getPropertyValue('--top-offset')) || 0;
      this.transformDuration = this.parseDuration(this.computedStyles.getPropertyValue('--transform-duration') || '0s');

      this.footer = this.querySelector('.section--footer .parallax-effect__section-wrapper');
      this.isFooterActive = false;

      this.setUpSlides();

      if (!this.eventsDeclared) {
        window.addEventListener('wheel', this.bindOnWheel, { passive: false });
        window.addEventListener('touchstart', this.bindOnTouchStart, { passive: true });
        window.addEventListener('resize', this.bindOnResize);
        this.eventsDeclared = true;
      }
    }

    removeEvents() {
      if (this.eventsDeclared) {
        window.removeEventListener('wheel', this.bindOnWheel, { passive: false });
        window.removeEventListener('touchstart', this.bindOnTouchStart, { passive: true });
        window.removeEventListener('resize', this.bindOnResize);

        this.eventsDeclared = false;
      }
    }

    setUpSlides() {
      this.slides = [];
      let index = 0;
      this.allSlides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        if (slideRect.width > 0) {
          if (slide.classList.contains('section--footer')) {
            this.footerIndex = index;
          }
          slide.dataset.index = index;
          this.slides.push(slide);
          index++;
        } else {
          slide.removeAttribute('data-index');
        }
      });

      this.totalSlides = this.slides.length;
      this.setSlidesPositions();
    }

    setSlidesPositions() {
      this.slidesPositions = [];
      this.slides.forEach((slide) => {
        let slidePosition = slide.offsetTop;
        if (slide.classList.contains('section--footer')) {
          slidePosition = (this.slidesPositions[this.slidesPositions.length - 1] || parseFloat(this.slides[this.slides.length - 1].dataset.position) || 0) + slide.getBoundingClientRect().height + 1;
        }
        slide.dataset.position = slidePosition;
        this.slidesPositions.push(slidePosition);
      });
    }

    navigateToSlides(index) {
      if (index < 0 ||index >= this.totalSlides) {
        this.isAnimating = false;
        return;
      }
      if (this.footer && this.footer.scrollTop > 0 && this.currentIndex == this.footerIndex) {
        this.isAnimating = false;
        return;
      }


      const newPosition = this.slidesPositions[index] || parseFloat(this.slides[index].dataset.position) || 0;
      this.style.setProperty('--transform-offset', `${-newPosition}px`);
      this.currentPosition = newPosition;
      this.currentIndex = index;

      if (this.currentIndex === 0) {
        document.documentElement.classList.add('first-slide');
      } else {
        document.documentElement.classList.remove('first-slide');
      }

      this.slides.forEach((slide, i) => {
        const slidePosition = parseFloat(slide.dataset.position) || this.slidesPositions[i] || 0;

        if (i < index) {
          const offset = newPosition - slidePosition;
          slide.classList.add('vertical-fixed', 'vertical-overlay');
          slide.style.setProperty('--vertical-offset', `${offset}px`);
        } else {
          slide.style.setProperty('--vertical-offset', `0px`);
          setTimeout(() => {
            slide.classList.remove('vertical-fixed');
          }, this.transformDuration);
          setTimeout(() => {
            slide.classList.remove('vertical-overlay');
          }, this.transformDuration - 100);
        }
      })

      // Allow next scroll after animation completes
      this.animatingTimeout();
    }

    animatingTimeout() {
      setTimeout(() => {
        this.isAnimating = false;
      }, this.transformDuration + 100);

      // Block wheel events for extended period after navigation
      this.isWheelBlocked = true;
      if (this.wheelBlockTimeout) {
        clearTimeout(this.wheelBlockTimeout);
      }
      // Use device-specific cooldown
      const cooldown = this.lastInputWasMouse ? this.mouseNavigationCooldown : this.touchpadNavigationCooldown;
      const blockDuration = Math.max(this.transformDuration + 100, cooldown);
      this.wheelBlockTimeout = setTimeout(() => {
        this.isWheelBlocked = false;
        this.wheelDeltaAccumulator = 0;
        this.wheelEventCount = 0;
        this.wheelGestureStartTime = 0;
      }, blockDuration);
    }

    onWheel(event) {
      if (!this.checkIfEffectAvailable()) return;
      if (this.footer &&  this.currentIndex == this.footerIndex) {
        if (this.footer.scrollTop > 0 || event.deltaY > 0) {
          return;
        }
      }

      // Prevent multiple scrolls while animating or blocked
      if (this.isAnimating || this.isWheelBlocked) {
        event.preventDefault();
        return;
      }

      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        return;
      }

      // Prevent default scroll behavior while within parallax bounds
      event.preventDefault();

      const now = Date.now();

      // Detect if this is likely a mouse wheel vs touchpad
      // Mouse wheels typically have larger deltaY values (100+) and fewer events
      // Touchpads have smaller deltaY values (often < 10) and many events
      const isMouse = Math.abs(event.deltaY) > 50;

      // Enforce device-specific cooldown between navigations
      const cooldown = isMouse ? this.mouseNavigationCooldown : this.touchpadNavigationCooldown;
      if (this.lastNavigationTime > 0 && now - this.lastNavigationTime < cooldown) {
        return;
      }

      // Start new gesture if needed
      if (this.wheelEventCount === 0) {
        this.wheelGestureStartTime = now;
      }

      // Increment event count for this gesture
      this.wheelEventCount++;

      // Accumulate scroll delta
      this.wheelDeltaAccumulator += event.deltaY;

      // Clear previous timeout if exists
      if (this.wheelTimeout) {
        clearTimeout(this.wheelTimeout);
      }

      // Reset accumulator after brief period of inactivity
      this.wheelTimeout = setTimeout(() => {
        this.wheelDeltaAccumulator = 0;
        this.wheelEventCount = 0;
        this.wheelGestureStartTime = 0;
      }, 200);

      // Calculate gesture duration
      const gestureDuration = now - this.wheelGestureStartTime;

      // Adjust requirements based on input device
      let requiredEvents, requiredDuration, requiredThreshold;
      if (isMouse) {
        // Mouse wheel: less events needed, shorter duration OK
        requiredEvents = 1;
        requiredDuration = 0;
        requiredThreshold = this.wheelThreshold;
      } else {
        // Touchpad: more events needed, longer duration required, higher threshold
        requiredEvents = 5; // Increased from 4 to 5
        requiredDuration = this.minGestureDuration;
        requiredThreshold = this.wheelThreshold * 1.2; // 20% higher threshold for touchpad
      }

      // Check all conditions
      const hasEnoughDelta = Math.abs(this.wheelDeltaAccumulator) >= requiredThreshold;
      const hasEnoughEvents = this.wheelEventCount >= requiredEvents;
      const hasEnoughDuration = gestureDuration >= requiredDuration;

      // Only navigate if ALL conditions are met
      if (hasEnoughDelta && hasEnoughEvents && hasEnoughDuration) {
        const delta = Math.sign(this.wheelDeltaAccumulator);
        const newIndex = this.currentIndex + delta;

        // Reset all tracking variables
        this.wheelDeltaAccumulator = 0;
        this.wheelEventCount = 0;
        this.wheelGestureStartTime = 0;
        this.lastWheelTime = now;
        this.lastNavigationTime = now;
        this.lastInputWasMouse = isMouse;

        this.isAnimating = true;
        this.navigateToSlides(newIndex);
      } else {
        // Update last wheel time for tracking
        this.lastWheelTime = now;
      }
    }

    onTouchStart(event) {
      if (!this.checkIfEffectAvailable()) return;
      this.touchStartY = event.touches[0].clientY;
      this.touchStartX = event.touches[0].clientX;
      this.isSwiping = false;
      this.swipeDirection = null;
      window.addEventListener('touchmove', this.bindOnTouchMove, { passive: false });
      window.addEventListener('touchend', this.bindOnTouchEnd, { passive: true });
    }

    onTouchMove(event) {
      if (!this.checkIfEffectAvailable()) return;
      const currentY = event.touches[0].clientY;
      const currentX = event.touches[0].clientX;
      const deltaY = this.touchStartY - currentY;
      const deltaX = this.touchStartX - currentX;

      if (this.footer &&  this.currentIndex == this.footerIndex) {
        if (this.footer.scrollTop > 0 || deltaY > 0) {
          return;
        }
      }

      if (this.currentIndex === 0) {
        if (deltaY > 0) {
          document.documentElement.classList.remove('first-slide')
        } else {
          window.removeEventListener('touchmove', this.bindOnTouchMove, { passive: false });
          return;
        }
      }

      // Prevent multiple scrolls while animating
      if (this.isAnimating) {
        if (this.swipeDirection === 'vertical') {
          if(event.cancelable) event.preventDefault();
        }
        return;
      }

      if (!this.isSwiping && (Math.abs(deltaY) > 5 || Math.abs(deltaX) > 5)) {
        this.isSwiping = true;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          this.swipeDirection = 'vertical';
        } else {
          this.swipeDirection = 'horizontal';
          window.removeEventListener('touchmove', this.bindOnTouchMove, { passive: false });
          return;
        }
      }

      // For vertical swipes or while animating, prevent default
      if (this.swipeDirection === 'vertical') {
        if(event.cancelable) event.preventDefault();
      }
    }

    onTouchEnd(event) {
      if (!this.checkIfEffectAvailable()) return;

      if (this.isAnimating) {
        return;
      }

      if (this.swipeDirection !== 'vertical') {
        this.isSwiping = false;
        this.swipeDirection = null;
        return;
      }

      const touchEndY = event.changedTouches[0].clientY;
      const deltaY = this.touchStartY - touchEndY;

      this.isSwiping = false;
      this.swipeDirection = null;

      if (Math.abs(deltaY) < 50) {
        return;
      }

      // Determine direction: positive deltaY means swipe up (next slide)
      const delta = deltaY > 0 ? 1 : -1;
      const newIndex = this.currentIndex + delta;

      if (newIndex < 0 || newIndex >= this.totalSlides) {
        return;
      }

      this.isAnimating = true;

      this.navigateToSlides(newIndex);
      window.removeEventListener('touchmove', this.bindOnTouchMove, { passive: false });
      window.removeEventListener('touchend', this.bindOnTouchEnd, { passive: true });
    }

    onResize() {
      this.removeEvents();
      requestAnimationFrame(() => {
        this.setUp();
      })
    }

    parseDuration(duration) {
      const trimmed = duration.trim();
      if (trimmed.endsWith('ms')) {
        return parseFloat(trimmed);
      } else if (trimmed.endsWith('s')) {
        return parseFloat(trimmed) * 1000;
      }
      return 0;
    }

    checkIfEffectAvailable() {
      const menuDrawer = document.querySelector('header-drawer > details');
      if(menuDrawer.hasAttribute('open')) return false;

      const headerSearch = document.querySelector('.header__search > details');
      if(headerSearch.hasAttribute('open')) return false;

      const cartDrawer = document.querySelector('cart-drawer');
      if(cartDrawer.classList.contains('active')) return false;

      return true;
    }
  }
  customElements.define('parallax-effect', ParallaxEffect);
}